<template></template>
<script>
export default {
  methods: {
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let url = window.location.href.split('#')[0]
      let search = url.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    }
  },
  created() {
    console.log(window.location.href.split('?')[1].split('=')[1], 'orderNum');
    let orderNum = window.location.href.split('?')[1].split('=')[1];
    let appId = 'wxb9292d9d811b855f';
    let returnUrl = 'https://wxpay.youths.run';
    location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${returnUrl}&response_type=code&scope=snsapi_base&state=${orderNum}#wechat_redirect`)
    // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${returnUrl}&response_type=code&scope=snsapi_base&state=${orderNum}#wechat_redirect`;
  
  }
}
</script>



// WEBPACK FOOTER //
// src/page/transfer.vue